// コンバートエラーモーダル
const ModalConvertError = {
  namespaced: true,

  state: {
    modal: false,
    bukkenInfo: {
      id: null,
      bName: '',
      shopName: '',
    },
    errorList: [],
    errorSiteName: '',
    title: '',
  },
  getters: {
    getModal: state => {
      return state.modal
    },
    getBukkenInfo: state => {
      return state.bukkenInfo
    },
    getErrorList: state => {
      return state.errorList
    },
    getErrorSiteName: state => {
      return state.errorSiteName
    },
    getTitle: state => {
      return state.title
    },
  },
  mutations: {
    setModal(state, modal) {
      state.modal = modal
    },
    setBukkenInfo(state, info) {
      state.bukkenInfo = info
    },
    setErrorList(state, list) {
      state.errorList = list
    },
    setErrorSiteName(state, name) {
      state.errorSiteName = name
    },
    setTitle(state, title) {
      state.title = title
    },
  },
  actions: {
    set({ commit }, data) {
      commit('setModal', true)
      commit('setBukkenInfo', {
        id: data.b_info.id,
        bName: data.b_info.b_name,
        shopName: data.b_info.shop_name,
      })
      commit('setErrorList', data.contents ?? [])
      commit('setErrorSiteName', data.portal_site ?? '')
      commit('setTitle', data.title ?? '通信エラーが発生しました。')
    },
    reset({ commit }) {
      commit('setModal', false)
      commit('setBukkenInfo', {
        id: null,
        bName: '',
        shopName: '',
      })
      commit('setErrorList', [])
      commit('setErrorSiteName', '')
      commit('setTitle', '通信エラーが発生しました。')
    },
  },
}

export default ModalConvertError
